import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { showModalFinSesion, setCoordenadas } from "../redux/slices/appslice";
import { getCoordenadas } from "../utils";
import { cerrarSesion } from '../ws';
import M from 'materialize-css';

const MESSAGE = 'Tu navegador no soporta la geolocalización es necesaria para poder continuar.';
const GeolocationPermissionListener = () => {
  const location = useLocation();
  const appData = useSelector((state) => state.appData);
  const dispatch = useDispatch();
  const [permissionStatus, setPermissionStatus] = useState('unknown');

  const isAvisoRoute = (location.pathname && location.pathname.toLowerCase() === '/aviso') ||
                       (typeof window !== 'undefined' && window.location.pathname.toLowerCase() === '/aviso');

  useEffect(() => {
    if (isAvisoRoute) return;

    if (permissionStatus === 'denied') {
      dispatch(setCoordenadas(false));
      closeSesion();
    }

    if (permissionStatus === 'granted') {
      getLatLong();
    }
  }, [permissionStatus, isAvisoRoute]);

  async function closeSesion() {
    if (isAvisoRoute) return;
    let instanceModal = M.Modal.getInstance(document.getElementById('modalFinSesion'));
    if (instanceModal) {
      if (appData.user) {
        await cerrarSesion(appData);
        dispatch(showModalFinSesion({ texto: MESSAGE }));
      } else {
        dispatch(showModalFinSesion({ texto: MESSAGE }));
      }
    }
  }

  const getLatLong = async () => {
    if (isAvisoRoute) return;
    let coordenadas = await getCoordenadas();
    if (coordenadas) {
      dispatch(setCoordenadas(coordenadas));
    }
  };

  const handlePermissionChange = () => {
    if (isAvisoRoute) return;
    if (!navigator.permissions || !navigator.permissions.query) return;
    navigator.permissions.query({ name: 'geolocation' })
      .then(permission => {
        setPermissionStatus(permission.state);
      })
      .catch(error => {
        console.error('Error al obtener el estado del permiso de geolocalización:', error);
      });
  };

  useEffect(() => {
    if (isAvisoRoute) return;

    const checkPermissionStatus = async () => {
      if (isAvisoRoute) return;
      try {
        if (!navigator.permissions || !navigator.permissions.query) return;
        const permission = await navigator.permissions.query({ name: 'geolocation' });
        setPermissionStatus(permission.state);

        window.addEventListener('change', handlePermissionChange);
      } catch (error) {
        console.error('Error al obtener el estado del permiso de geolocalización:', error);
      }
    };

    document.body.addEventListener('click', checkPermissionStatus);

    const timer = setTimeout(() => {
      checkPermissionStatus();
    }, 1000);

    return () => {
      clearTimeout(timer);
      document.body.removeEventListener('click', checkPermissionStatus);
      window.removeEventListener('change', handlePermissionChange);
    };
  }, [isAvisoRoute]);

  return null;
};

export default GeolocationPermissionListener;
